import { render } from "./custom_6grid_pop_up.vue?vue&type=template&id=c0d3cde2"
import script from "./custom_6grid_pop_up.vue?vue&type=script&lang=js"
export * from "./custom_6grid_pop_up.vue?vue&type=script&lang=js"

import "./custom_6grid_pop_up.vue?vue&type=style&index=0&id=c0d3cde2&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__